import { render } from "./UpdatePaymentRecord.vue?vue&type=template&id=dc14854c&scoped=true"
import script from "./UpdatePaymentRecord.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentRecord.vue?vue&type=script&lang=js"

import "./UpdatePaymentRecord.vue?vue&type=style&index=0&id=dc14854c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc14854c"]])

export default __exports__